import React from 'react';
import { Row } from 'ui/Flex';
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined';
import { Link } from 'ui/Link';
import { alpha, Paper, styled, Typography } from '@mui/material';
import { ANALYTICS_AUDIENCES } from 'config/routes';
import { EGAEventName, useGAHelpers } from 'lib/hooks/useGAHelper';

const BannerPaper = styled(Paper)(({ theme }) => ({
    border: '1px solid',
    borderColor: theme.palette.divider,
    padding: theme.spacing(1.5, 2, 1.5, 2),
    backgroundColor: alpha(theme.palette.secondary.light, 0.8)
}));

const BannerLink = styled(Link)(({ theme }) => ({
    color: theme.palette.text.primary,
    fontWeight: 'bold',
    textDecoration: 'underline',
    '&:hover': {
        color: theme.palette.orange.core
    }
}));

interface AudienceAnalyticsTipBannerProps {
    audienceId?: string;
}

export const AudienceAnalyticsTipBanner: React.FC<AudienceAnalyticsTipBannerProps> = ({ audienceId }) => {
    const { logUserEvent } = useGAHelpers();
    const href = audienceId ? `${ANALYTICS_AUDIENCES}?audienceIds=${audienceId}` : ANALYTICS_AUDIENCES;
    const handleClick = React.useCallback(() => {
        logUserEvent(EGAEventName.ViewAudienceAnalyticsBannerClick);
    }, [logUserEvent]);
    return (
        <BannerPaper elevation={0}>
            <Row valign="center">
                <TipsAndUpdatesOutlinedIcon sx={{ fontSize: '1.5rem' }} />
                <Typography sx={{ ml: 2 }}>
                    You can filter and compare data across audiences in the Audience Analytics page.{' '}
                    <BannerLink onClick={handleClick} href={href}>
                        Click here
                    </BannerLink>{' '}
                    to compare this audience with your active users!
                </Typography>
            </Row>
        </BannerPaper>
    );
};
